import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface CommitteeMember {
  slno: number;
  name: string;
  position: string;
  category: string;
  occupation: string;
}

@Component({
  selector: 'app-instructors-page-one',
  templateUrl: './instructors-page-one.component.html',
  styleUrls: ['./instructors-page-one.component.scss']
})
export class InstructorsPageOneComponent implements OnInit {
  isToggled = false;

  committeeMembers: CommitteeMember[] = [
    { slno: 1, name: 'Dr.P.Nelson Raja', position: 'Chairman', category: 'Principal', occupation: 'Principal' },
    { slno: 2, name: 'Dr.K.R.Ramela', position: 'Member', category: 'Faculty Member', occupation: 'Professor' },
    { slno: 3, name: 'Ms.R.Nagadeepa', position: 'Member', category: 'Faculty Member', occupation: 'Assistant Professor' },
    { slno: 4, name: 'Mr.A.Athimoolam', position: 'Member', category: 'Faculty Member', occupation: 'Associate Professor' },
    { slno: 5, name: 'Mr.R.Pandi', position: 'Member', category: 'Faculty Member', occupation: 'Assistant Professor' },
    { slno: 6, name: 'Mr.M.Vishal(III – AI&ML)', position: 'Member', category: 'Student Member', occupation: 'Student' },
    { slno: 7, name: 'Ms.S.Pandeeswari(III ECE)', position: 'Member', category: 'Student Member', occupation: 'Student' }
  ];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {}

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  trackBySlno(index: number, item: CommitteeMember): number {
    return item.slno;
  }
}